import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { dealerReducer } from "./dealerReducer";
import { combineReducers } from "redux";
import { dealerContactModesReducer } from "./dealerContactModesReducer";
import { dealerContactInfosReducer } from "./dealerContactInfosReducer";

const listReducer = (state = initialState.partners.list, action) => {
  switch (action.type) {
    case types.LOAD_PARTNERS_STARTED: {
      const { key, page } = action;
      let result = { ...state };
      result[key] = { ...state[key] };
      result[key][page] = { ...result[key][page], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_PARTNERS_SUCCEEDED: {
      const { key, page, totalCount, totalPages } = action;
      let result = { ...state };
      result[key] = { ...state[key], totalCount, totalPages };
      result[key][page] = { ...result[key][page], ids: [...action.result], loading: false, loaded: true };
      return result;
    }

    case types.LOAD_PARTNERS_FAILED: {
      const { key, page } = action;
      let result = { ...state, [key]: { ...state[key] } };
      result[key][page] = { ...result[key][page], loading: false, loaded: false };
      return result;
    }

    case types.PARTNER_LIST_INVALIDATED: {
      return initialState.partners.list;
    }

    default:
      return state;
  }
};

const itemReducer = (state = initialState.partners.items, action) => {
  switch (action.type) {
    case types.LOAD_PARTNER_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }
    case types.LOAD_PARTNER_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true };
      return result;
    }

    case types.LOAD_PARTNER_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_PARTNER_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loaded: false };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: listReducer,
  items: itemReducer,
  dealers: dealerReducer,
  dealerContactModes: dealerContactModesReducer,
  dealerContactInfos: dealerContactInfosReducer
});
